import EventDispatcher from './events/EventDispatcher';
import Ticker from './Ticker';

let TIMERS = new Set();
let NEW_TIMERS = new Set();

/**
 * @class
 * @inheritDoc
 * @extends module:events.EventDispatcher
 * @classdesc Класс таймера
 */
class Timer extends EventDispatcher {

    /**
     * @constructor
     * @param {Function} onend функция, которая будет вызвана по окончанию таймера
     * @param {Number} timeout таймаут в кадрах или милисекундах
     * @param {Boolean} [repeat=false] нужно ли повторять таймер по его завершению
     */
    constructor(onend, timeout, repeat = false) {
        super();

        /** @ignore */
        this.repeat = repeat;

        /** @ignore */
        this.initialTimeout = timeout;

        /** @ignore */
        this.timeout = timeout;

        /** @ignore */
        this.destroy = false;

        /** @ignore */
        this.paused = false;

        if ('string' == typeof onend) {
            onend = () => eval(onend);
        }
        if (onend instanceof Function) {
            if (this.repeat) {
                this.on('end', onend);
            }
            else {
                this.on('end', onend);
            }

        }

        NEW_TIMERS.add(this);
    }

    destructor(){
        super.destructor();
        TIMERS.delete(this);
        NEW_TIMERS.delete(this);
    }

    /**
     * Updates timer state
     * @param {number} delta ms
     * @ignore
     */
    tick(delta) {

        if (this.destroy || this.paused) return;

        this.timeout -= delta;
        /**
         * Тик таймера
         * @event Timer#tick
         */
        this.emit("tick", {delta: delta, left: this.timeout});

        if (this.timeout <= 0) {

            let overtime = -this.timeout;
            /**
             * Окончание таймера
             * @event Timer#end
             */
            this.emit("end", {overtime: overtime});

            if (this.repeat) {
                this.rewind();
                this.timeout -= overtime;
            }
            else {
                this.destroy = true;
            }
        }
    }

    /**
     * Откат таймера в начальное состояние
     */
    rewind() {
        this.timeout = this.initialTimeout;
    }

    /**
     * Возобновление таймера
     */
    resume() {
        this.paused = false;
    }

    /**
     * Пауза таймера
     */
    pause() {
        this.paused = true;
    }
    
    /**
     * Завершение таймера сейчас
     */
    finish() {
        this.paused = false;
        this.tick(this.timeout);
    }

    //------------------------------------------------------------------------------------------------------------------
    // СЛУЖЕБНОЕ
    //------------------------------------------------------------------------------------------------------------------
    /**
     * Тик всех твинов
     * @param {Number} delta
     * @param {Iterable} [items] All tweens by default
     * @ignore
     */
    static tick(delta, items = TIMERS) {
        this.flush();
        for (let t of items) {
            t.tick(delta);
        }
        this.cleanup();
    }

    /**
     * Созданные при тике твины сливаются в общий котёл
     * @ignore
     */
    static flush() {
        for (let tween of NEW_TIMERS) {
            TIMERS.add(tween);
        }
        NEW_TIMERS.clear();
    }

    /**
     * Очистка помеченных на удаление
     * @ignore
     */
    static cleanup() {
        let destroyed = this.filter('destroy', true);
        this.destroy(destroyed);
    }

    /**
     * Уничтожение
     * @param {Iterable} [items] All by default
     * @ignore
     */
    static destroy(items = [...TIMERS, ...NEW_TIMERS]) {
        for (let t of items) {
            t.destructor();
        }
    }

    /**
     * Пометка на уничтожение при ближайшем тике
     * @param {Iterable} [items] All by default
     * @ignore
     */
    static softDestroy(items = [...TIMERS, ...NEW_TIMERS]) {
        for (let t of items) {
            t.destroy = true;
        }
    }

    /**
     * Найти все по критерию
     * @param {String} prop список объектов
     * @param {...*} values список значений
     * @return {Tween[]} все с таким значением указанного свойства (строгое стравнение)
     * @ignore
     */
    static filter(prop, ...values) {
        let result = [...TIMERS, ...NEW_TIMERS];
        if (undefined !== prop && values.length) {
            for (let val of values) {
                result = result.filter(
                    t => t[prop] === val
                );
            }
        }
        return result;
    }

    /** ignore */
    static get debugInfo() {
        return `TIMERS: ${TIMERS.size} +${NEW_TIMERS.size}`;
    }

    static clear(timer) {
        timer.destroy = true;
    }
}

Ticker.on("tick", (e) => {
    Timer.tick(e.delta);
});

export default Timer;